import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Media} from "../../models/media";
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-image-list',
    templateUrl: './image-list.component.html',
    styleUrls: ['./image-list.component.scss']
})
export class ImageListComponent implements OnInit {

    @Input() media: Array<Media> = [];
    @Input() code: string;
    @Input() rowSize: number = 5;
    @Output() clickedMedia: EventEmitter<Media> = new EventEmitter<Media>();

    private cellSize;
    environment = environment;

    constructor() {
    }

    ngOnInit() {
        this.cellSize = Math.floor(100 / this.rowSize);
    }

    choseMedia(media: Media) {
        this.clickedMedia.emit(media)
    }
}
